import React, { useState, useEffect } from 'react';

// ERP Module Release Announcement Pop-up
const ERPReleasePopup = ({ isOpen = true, onClose }) => {
  const [activeModule, setActiveModule] = useState('SHAML_Human_Capital');
  const [activeTab, setActiveTab] = useState('features');
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setIsVisible(true), 50);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      onClose?.();
    }, 300);
  };

  // Brand color: rgb(158, 141, 96)
  const brandColor = 'rgb(158, 141, 96)';
  const brandColorLight = 'rgba(158, 141, 96, 0.1)';
  const brandColorMedium = 'rgba(158, 141, 96, 0.2)';
  const brandColorBorder = 'rgba(158, 141, 96, 0.3)';
 const PdfIcon = ({ className = "w-10 h-10" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="48"
    viewBox="0 0 56 48"
    fill="none"
    className={className}
  >
    <image
      href={`${process.env.PUBLIC_URL}/shaml.svg`}
      width="56"
      height="48"
      preserveAspectRatio="none"
    />
  </svg>
);

   const PdfmasterIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 44" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.4336 0.732178H20.739L32.8633 13.3697V37.9497C32.8633 41.0289 30.3721 43.52 27.3036 43.52H6.4336C3.35442 43.52 0.863281 41.0289 0.863281 37.9497V6.30249C0.863227 3.22332 3.35437 0.732178 6.4336 0.732178Z" fill="#ED676A"></path>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.739 0.732178L20.7283 13.2734H32.8633L20.739 0.732178Z" fill="#F39597"></path>
<path d="M7.05371 32.6574V24.8418H10.3788C11.2021 24.8418 11.8543 25.0663 12.3461 25.5261C12.8379 25.9751 13.0838 26.5846 13.0838 27.3436C13.0838 28.1027 12.8379 28.7122 12.3461 29.1612C11.8543 29.621 11.2021 29.8455 10.3788 29.8455H9.05305V32.6574H7.05371ZM9.05305 28.1455H10.1543C10.4536 28.1455 10.6889 28.0814 10.8493 27.9317C11.0096 27.7927 11.0952 27.6003 11.0952 27.3437C11.0952 27.0871 11.0097 26.8947 10.8493 26.7557C10.6889 26.606 10.4537 26.5418 10.1543 26.5418H9.05305V28.1455ZM13.907 32.6574V24.8418H16.6762C17.2214 24.8418 17.7346 24.9166 18.2158 25.077C18.6969 25.2374 19.1352 25.4619 19.5201 25.772C19.905 26.0713 20.2151 26.4776 20.4396 26.9908C20.6534 27.504 20.7711 28.0921 20.7711 28.7549C20.7711 29.4071 20.6535 29.9952 20.4396 30.5083C20.2151 31.0216 19.905 31.4278 19.5201 31.7272C19.1352 32.0372 18.6969 32.2617 18.2158 32.4222C17.7346 32.5825 17.2214 32.6574 16.6762 32.6574H13.907ZM15.8636 30.9574H16.4409C16.751 30.9574 17.0397 30.9254 17.307 30.8505C17.5635 30.7757 17.8095 30.658 18.0447 30.4977C18.2692 30.3373 18.451 30.1128 18.5793 29.8134C18.7076 29.5141 18.7717 29.1612 18.7717 28.7549C18.7717 28.338 18.7076 27.9851 18.5793 27.6858C18.451 27.3865 18.2692 27.1619 18.0447 27.0015C17.8095 26.8412 17.5636 26.7235 17.307 26.6487C17.0397 26.5739 16.751 26.5418 16.4409 26.5418H15.8636V30.9574ZM21.7761 32.6574V24.8418H27.3357V26.5418H23.7754V27.7927H26.6194V29.482H23.7754V32.6574H21.7761Z" fill="white"></path>
</svg>);
  // Module configurations
  const modules = {
    SHAML_Human_Capital: {
      name: '',
      icon: '',
      version: 'v2.0.0',
      releaseDate: 'January 19, 2026',
      features: [
         { 
          id: 1,
          title: 'HR Orientation Form', 
          description: 'Collect essential information from new employees and provide an overview of company policies, procedures, and resources during the onboarding process.', 
          status: 'New',
          document: 'HR Orientation Form 1.pdf'
        },
         { 
          id: 1,
          title: 'MSS Clearance Form', 
          description: 'Document and confirm the clearance of an employee or department from all responsibilities, assets, and obligations before separation or transfer.', 
          status: 'New',
          document: 'MSS Clearance Form 1.pdf'
        },
             { 
          id: 1,
          title: 'ESS Exit Interview Form', 
          description: 'Capture feedback from employees leaving the organization, helping HR understand reasons for departure and identify opportunities for improvement.', 
          status: 'New',
          document: 'ESS Exit Interview Form 1.pdf'
        },
        { 
          id: 1,
          title: 'New Born Gift Automation', 
          description: 'Automatically selects, personalizes, and delivers gifts for newborns, streamlining the gifting process', 
          status: 'enhanced',
          document: 'ESS New Born Gift Automation.pdf'
        },
        { 
          id: 2,
          title: 'Marriage Gift Automation', 
          description: 'Automatically selects, personalizes, and delivers wedding gifts, streamlining the gifting process', 
          status: 'enhanced',
          document: 'SHAML_Human_Capital_Marriage_Guide.pdf'
        },
        { 
          id: 3,
          title: 'Contract Renewals', 
          description: 'Tracks employee contract expiration dates and notifies in advance for timely renewal', 
          status: 'enhanced',
          document: 'SHAML_Human_Capital_Contract_Renewal_Guide.pdf'
        },
        { 
          id: 4,
          title: 'Probation period', 
          description: 'Monitor and manage an employee\'s initial trial period, tracking performance and notifying relevant actions before confirmation or extension', 
          status: 'enhanced',
          document: 'SHAML_Human_Capital_Probation_Guide.pdf'
        },
        { 
          id: 5,
          title: 'Resignation Request', 
          description: 'A formal process for employees to submit their intent to leave the organization', 
          status: 'new',
          document: 'SHAML_Human_Capital_Resignation_Guide.pdf'
        },
        { 
          id: 6,
          title: 'Schooling allowance', 
          description: 'Manage and automate education benefits for employees\' dependents', 
          status: 'enhanced',
          document: 'SHAML_Human_Capital_Schooling_Guide.pdf'
        }
      ],
      guides: [

         { 
          id: 1,
          title: 'HR Orientation Form', 
          type: 'PDF', 
          size: '0.5 MB', 
         icon: <PdfIcon />,
          filename: 'HR_Orientation_Form.pdf',
          canView: true,
          canDownload: true
        },
        { 
          id: 2,
          title: 'MSS Clearance Form', 
          type: 'PDF', 
           size: '0.36 MB', 
          icon: <PdfIcon />,
          filename: 'MSS_Clearance_Form.pdf',
          canView: true,
          canDownload: true
        },
        { 
          id: 3,
          title: 'ESS Exit Interview Form', 
          type: 'PDF', 
          size: '0.05 MB', 
          icon: <PdfIcon />,
          filename: 'ESS_Exit_Interview_Form.pdf',
          canView: true,
          canDownload: true
        },

        { 
          id: 1,
          title: 'New Born Gift Automation', 
          type: 'PDF', 
          size: '0.5 MB', 
         icon: <PdfIcon />,
          filename: 'ESS New Born Gift Automation.pdf',
          canView: true,
          canDownload: true
        },
        { 
          id: 2,
          title: 'Marriage Gift Automation', 
          type: 'PDF', 
           size: '0.6 MB', 
          icon: <PdfIcon />,
          filename: 'ESS Marriage Gift Automation.pdf',
          canView: true,
          canDownload: true
        },
        { 
          id: 3,
          title: 'Contract Renewals', 
          type: 'PDF', 
          size: '0.05 MB', 
          icon: <PdfIcon />,
          filename: 'Contract Renewal.pdf',
          canView: true,
          canDownload: true
        },
        { 
          id: 4,
          title: 'Probation period', 
          type: 'PDF', 
          size: '0.05 MB', 
         icon: <PdfIcon />,
          filename: 'MSS Probation form.pdf',
          canView: true,
          canDownload: true
        },
         { 
          id: 4,
          title: 'Resignation Request', 
          type: 'PDF', 
          size: '0.04 MB', 
       icon: <PdfIcon />,
          filename: 'ESS Resignation.pdf',
          canView: true,
          canDownload: true
        },
         { 
          id: 4,
          title: 'Schooling allowance', 
          type: 'PDF', 
          size: '0.04 MB', 
          icon: <PdfIcon />,
          filename: 'ESS Schooling Allowance.pdf',
          canView: true,
          canDownload: true
        }
      ],
      support: { team: 'HR Systems Team', email: 'hr.erp@ahc.sa', ext: '5001' }
    },
    SHAML_Procurement: {
      name: '',
      icon: '',
      version: 'v2.0.0',
      releaseDate: 'January 6, 2026',
      features: [
        { 
          id: 1,
          title: 'PR Workflow Enhancements', 
          description: 'A new action for "Rework" will be available for approvers, which will allow approvers to send the PR back to the initiator to make necessary adjustments. While "Reject" option will be utilized for canceling the PR request', 
          status: 'enhanced',
          document: 'SHAML_Procurement_Smart_Portal_Guide.pdf'
        },
        { 
          id: 2,
          title: 'SES Workflow Enhancements', 
          description: 'Approvers will be able to see if there are any error related to the SES during approval process, in addition to that minor issues were resolved to improve the user experience', 
          status: 'enhanced',
          document: 'SHAML_Procurement_Vendor_Guide.pdf'
        },
        { 
          id: 3,
          title: 'PR Creation Simplified Form', 
          description: 'A simplified user interface has been implemented to improve the user experience, while the original layout can still be applied as needed', 
          status: 'enhanced',
          document: 'SHAML_Procurement_Inventory_Guide.pdf'
        },
       
      ],
      guides: [
        { 
          id: 1,
          title: 'PR Simplified Form', 
          type: 'PDF', 
          size: '1.1 MB', 
            icon: <PdfIcon />,
          filename: 'PR_Simplified_Form.pdf',
          canView: true,
          canDownload: true
        },
         { 
          id: 2,
          title: 'Procure to Pay PR PO Workflow Details', 
          type: 'PDF', 
          size: '2.1 MB', 
            icon: <PdfIcon />,
          filename: 'Procure_to_Pay_PR_PO_Workflow_Details.pdf',
          canView: true,
          canDownload: true
        },
        { 
          id: 3,
          title: 'Service Enter Sheet', 
          type: 'PDF', 
          size: '1.1 MB', 
            icon: <PdfIcon />,
          filename: 'Service_Enter_Sheet.pdf',
          canView: true,
          canDownload: true
        }
        ,
         { 
          id: 4,
          title: 'PR flexible Workflow User Manual', 
          type: 'PDF', 
          size: '2.1 MB', 
            icon: <PdfIcon />,
          filename: 'MM_PR flexible Workflow_User Manual.pdf',
          canView: true,
          canDownload: true
        },
        { 
          id: 5,
          title: 'PR Simplied form User manual', 
          type: 'PDF', 
          size: '1.1 MB', 
            icon: <PdfIcon />,
          filename: 'MM_PR Simplied form_User manual (002).pdf',
          canView: true,
          canDownload: true
        }
      ],
      support: { team: 'Supply Chain Systems', email: 'mm.erp@ahc.sa', ext: '5002' }
    }
  };

  const currentModule = modules[activeModule];
 

  // File handling functions
  const handleViewFile = (filename, title) => {
    // Construct the file path in public folder
    const filePath = `/${activeModule}/${filename}`;
    
    // For PDFs, open in new tab
    if (filename.endsWith('.pdf')) {
      window.open(filePath, '_blank', 'noopener,noreferrer');
    } 
    // For videos, you might want to open in a modal or new tab
    else if (filename.endsWith('.mp4')) {
      // Open video in new tab or custom video player
      window.open(filePath, '_blank', 'noopener,noreferrer');
    }
    
    console.log(`Viewing: ${title} (${filename})`);
    // You could add analytics tracking here
  };

  const handleDownloadFile = (filename, title) => {
    debugger
    const filePath = `/${activeModule}/${filename}`;
    
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = filePath;
    link.download = filename;
    link.target = '_blank';
    
    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log(`Downloading: ${title} (${filename})`);
    // You could add analytics tracking here
  };

  const handleViewFeatureDocument = (documentName, featureTitle) => {
    const filePath = `/SHAML_Documents/${activeModule}/Features/${documentName}`;
    window.open(filePath, '_blank', 'noopener,noreferrer');
    console.log(`Viewing feature document: ${featureTitle} (${documentName})`);
  };

  const handleProceedToSHAML = () => {
    // Redirect to SHAML platform or close popup and continue
    alert(`Redirecting to ${currentModule.name} module in SHAML Platform...`);
    handleClose();
    // In real implementation:
    // window.location.href = 'https://shaml.ahc.sa/';
  };



  if (!isOpen) return null;

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-all duration-300 ${
        isVisible && !isClosing ? 'opacity-100' : 'opacity-0'
      }`}
      style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}
    >
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/30 backdrop-blur-sm"
        onClick={handleClose}
      />
      
      {/* Main Modal */}
      <div 
        className={`relative w-full max-w-4xl max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl transition-all duration-500 bg-white ${
          isVisible && !isClosing 
            ? 'scale-100 translate-y-0' 
            : 'scale-95 translate-y-8'
        }`}
        style={{ boxShadow: '0 25px 50px -12px rgba(158, 141, 96, 0.25)' }}
      >
        {/* Decorative top border */}
        <div 
          className="absolute top-0 left-0 right-0 h-1"
          style={{ background: `linear-gradient(90deg, ${brandColor}, rgba(158, 141, 96, 0.5), ${brandColor})` }}
        />
        
        {/* Header */}
        <div className="relative px-8 pt-7 pb-5 border-b" style={{ borderColor: brandColorBorder }}>
          <div className="flex items-start justify-between mb-6">
            <div className="flex items-center gap-4">
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center shadow-lg"
             
              >
                <img src='data:image/svg+xml;base64,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'/>
              </div>
              <div>
                <div className="flex items-center gap-3">
                  <h1 
                    className="text-xl font-bold tracking-tight"
                    style={{ color: brandColor }}
                  >
                    SHAML Platform Release
                  </h1>
                  <span 
                    className="px-2.5 py-1 text-xs font-semibold rounded-full border animate-pulse"
                    style={{ 
                      backgroundColor: brandColorLight,
                      color: brandColor,
                      borderColor: brandColorBorder
                    }}
                  >
                    {currentModule?.version}
                  </span>
                </div>
                <p className="text-gray-500 mt-1 text-sm">
                  New features and enhancements for SHAML Platform
                </p>
              </div>
            </div>
            
            <button 
              onClick={handleClose}
              className="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-gray-600 transition-all hover:rotate-90 duration-300"
              style={{ backgroundColor: brandColorLight }}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Module Selector */}
          <div 
            className="flex gap-2 p-1.5 rounded-xl"
            style={{ backgroundColor: brandColorLight }}
          >
            {Object.entries(modules).map(([key, module]) => (
              <button
                key={key}
                onClick={() => {
                  setActiveModule(key);
                  setActiveTab('features');
                }}
                className="flex-1 px-4 py-3 rounded-lg text-sm font-semibold transition-all duration-300 flex items-center justify-center gap-2"
                style={activeModule === key ? {
                  backgroundColor: brandColor,
                  color: 'white',
                  boxShadow: `0 4px 15px -3px rgba(158, 141, 96, 0.4)`
                } : {
                  color: brandColor,
                  backgroundColor: 'transparent'
                }}
              >
                <span className="text-lg">{module.icon}</span>
                <span>{key.replace('_', ' ')}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Module Info Bar */}
        <div 
          className="px-8 py-3 border-b"
          style={{ backgroundColor: brandColorLight, borderColor: brandColorBorder }}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold" style={{ color: brandColor }}>
                  {currentModule.name}
                </span>
              </div>
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span>Release: {currentModule.releaseDate}</span>
              </div>
            </div>
            
            {/* Sub-tabs */}
            <div 
              className="flex gap-1 p-1 rounded-lg"
              style={{ backgroundColor: 'white' }}
            >
              {[
                { id: 'features', label: 'Features', icon: '✨' },
                { id: 'guides', label: 'Guides', icon: '📖' },
                { id: 'support', label: 'Support', icon: '🛟' }
              ].map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className="px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 flex items-center gap-1.5"
                  style={activeTab === tab.id ? {
                    backgroundColor: brandColor,
                    color: 'white'
                  } : {
                    color: brandColor
                  }}
                >
                  <span>{tab.icon}</span>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        
        {/* Content Area */}
        <div className="relative px-8 py-6 max-h-[45vh] overflow-y-auto custom-scrollbar bg-white">
          
          {/* Features Tab */}
          {activeTab === 'features' && (
            <div className="space-y-3 animate-fadeIn">
              {currentModule.features.map((feature) => (
                <div 
                  key={feature.id}
                  className="group p-4 rounded-xl border transition-all duration-300 hover:shadow-md"
                  style={{ 
                    borderColor: brandColorBorder,
                    backgroundColor: 'white'
                  }}
                >
                  <div className="flex items-start justify-between gap-4 cursor-pointer">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <h3 className="font-semibold text-gray-800 text-sm">{feature.title}</h3>
                        <span 
                          className="px-1.5 py-0.5 text-[10px] font-bold uppercase rounded"
                          style={feature.status === 'new' ? {
                            backgroundColor: brandColorMedium,
                            color: brandColor
                          } : {
                            backgroundColor: '#f1f5f9',
                            color: '#64748b'
                          }}
                        >
                          {feature.status}
                        </span>
                      </div>
                      <p className="text-gray-500 text-xs mb-3 leading-relaxed">{feature.description}</p>
                      
                      {/* Feature document button */}
                     
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          
          {/* Guides Tab */}
          {activeTab === 'guides' && (
            <>
            <div className="space-y-3 animate-fadeIn">
              {currentModule.guides.map((guide) => (
                
                <div 
                  key={guide.id}
                  className="group flex items-center justify-between p-4 rounded-xl border transition-all duration-300"
                  style={{ borderColor: brandColorBorder }}
                >
                  <div className="flex items-center gap-4">
                    <div 
                      className="w-11 h-11 rounded-lg flex items-center justify-center group-hover:scale-105 transition-transform"
                     
                    >
                      <span className="text-lg">{guide.icon}</span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 text-sm">{guide.title}</h3>
                      <p className="text-gray-400 text-xs mt-0.5">{guide.type}  {guide.size}</p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    {guide.canView && (
                      <button 
                        onClick={() => handleViewFile(guide.filename, guide.title)}
                        className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-300 flex items-center gap-1 border"
                        style={{ 
                          borderColor: brandColorBorder,
                          color: brandColor
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = brandColor;
                          e.currentTarget.style.color = 'white';
                          e.currentTarget.style.borderColor = brandColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.style.color = brandColor;
                          e.currentTarget.style.borderColor = brandColorBorder;
                        }}
                      >
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        View
                      </button>
                    )}
                    {guide.canDownload && (
                      <button 
                        onClick={() => handleDownloadFile(guide.filename, guide.title)}
                        className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-300 flex items-center gap-1 border"
                        style={{ 
                          borderColor: brandColorBorder,
                          color: brandColor
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = brandColor;
                          e.currentTarget.style.color = 'white';
                          e.currentTarget.style.borderColor = brandColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.style.color = brandColor;
                          e.currentTarget.style.borderColor = brandColorBorder;
                        }}
                      >
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        Download
                      </button>
                    )}
                  </div>
                </div>
              ))}
              
              {/* Training Banner */}
             
           
            </div>
                {activeModule ==="SHAML_Human_Capital" && (
        
            <div 
                className="mt-4 p-5 rounded-xl border overflow-hidden relative"
                style={{ 
                  backgroundColor: brandColorLight,
                  borderColor: brandColorBorder
                }}
              >
                <div className="relative flex items-center gap-4">
                  <div 
                    className="w-14 h-14 rounded-xl flex items-center bg-white justify-center "
                
                  >
                   <PdfIcon></PdfIcon>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-800">{currentModule.name} HR Workflows and Processes </h3>
                    <p className="text-gray-500 text-sm mt-1">Streamline and automate core HR functions, including employee lifecycle management, approvals, and HR-related workflows </p>
                  </div>
                  <button 
                    onClick={() => handleViewFile("HR_Services_And_Processes.pdf", "SHAML_Human_Capital")}
                    className="px-5 py-2.5 rounded-lg text-white text-sm font-semibold transition-all duration-300 hover:shadow-lg"
                    style={{ 
                      backgroundColor: brandColor,
                      boxShadow: `0 4px 15px -3px rgba(158, 141, 96, 0.4)`
                    }}
                  >
                    View
                  </button>
                </div>
              </div>
              )}
              </>
          )}
          
          {/* Support Tab */}
         {activeTab === 'support' && (
  <div className="space-y-4 animate-fadeIn">
    {/* Support Contact Card */}

    {/* Quick Resources */}
    <div className="grid grid-cols-1 gap-3">
      {/* Clickable Image */}
      <a href="https://daam.awjholding.com/" target="_blank" rel="noopener noreferrer">
        <img src='/dam.png' alt="DAAM Portal" className="rounded-lg cursor-pointer hover:shadow-md" />
      </a>

      {/* <div 
        className="p-4 rounded-xl border transition-all cursor-pointer hover:shadow-md"
        style={{ borderColor: brandColorBorder }}
        onClick={() => window.open('https://lms.ahc.sa/', '_blank')}
      >
        <div className="flex items-center gap-3">
          <div 
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: brandColorMedium }}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h4 className="text-gray-800 text-sm font-medium">Training Sessions</h4>
            <p className="text-gray-400 text-xs">Book via LMS Portal</p>
          </div>
        </div>
      </div> */}
    </div>

    {/* Quick Actions */}

  </div>
)}

        </div>
        
        {/* Footer */}
        <div
          className="relative px-8 py-4 border-t flex justify-end   items-center"
          style={{ borderColor: brandColorBorder, backgroundColor: brandColorLight }}
        >
           
          <button
            onClick={handleProceedToSHAML}
            className="px-6 py-2.5 rounded-lg text-white text-sm font-semibold transition-all duration-300 hover:shadow-lg hover:scale-[1.02]"
            style={{
              backgroundColor: brandColor,
              boxShadow: `0 4px 15px -3px rgba(158, 141, 96, 0.4)`
            }}
          >
            Proceed to SHAML
          </button>
        </div>
      </div>
      
      {/* Custom styles */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn > * {
          animation: fadeIn 0.4s ease-out backwards;
        }
        .animate-fadeIn > *:nth-child(1) { animation-delay: 0.1s; }
        .animate-fadeIn > *:nth-child(2) { animation-delay: 0.2s; }
        .animate-fadeIn > *:nth-child(3) { animation-delay: 0.3s; }
        .animate-fadeIn > *:nth-child(4) { animation-delay: 0.4s; }
        .animate-fadeIn > *:nth-child(5) { animation-delay: 0.5s; }
        .animate-fadeIn > *:nth-child(6) { animation-delay: 0.6s; }
        
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(158, 141, 96, 0.1);
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(158, 141, 96, 0.3);
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(158, 141, 96, 0.5);
        }
      `}</style>
    </div>
  );
};

export default ERPReleasePopup;